import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import CenterModal from "@ats/src/components/modals/CenterModal";
import Button from "@ats/src/components/shared/Button";

interface Props {
  userName: string;
  actionType: "downgrade" | "deactivate";
  onConfirm: () => void;
  onCancel: () => void;
}

function ApiKeyRevokeWarningModal(props: Props) {
  const { userName, actionType, onConfirm, onCancel } = props;

  const title = `This will revoke ${userName}'s API key`;

  const actionDescription =
    actionType === "downgrade"
      ? "Changing their role to a non-admin role"
      : "Deactivating their account";

  return (
    <CenterModal headerTitleText={title} onCancel={onCancel}>
      <Styled.Instructions>
        {actionDescription} will automatically revoke their API key. Any integrations using this
        API key will immediately stop working.
      </Styled.Instructions>
      <Styled.ButtonContainer>
        <Button dangerous={true} onClick={onConfirm}>
          {actionType === "downgrade" ? "Change role anyway" : "Deactivate anyway"}
        </Button>
        <Button styleType="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Styled.ButtonContainer>
    </CenterModal>
  );
}

export default ApiKeyRevokeWarningModal;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Instructions = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: ApiKeyRevokeWarningModal_Instructions;
    ${[t.mb(5)]}
  `;
});

Styled.ButtonContainer = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: ApiKeyRevokeWarningModal_ButtonContainer;
    display: flex;
    > * {
      ${t.mr(3)}

      &:last-of-type {
        ${t.mr(0)}
      }
    }
  `;
});
